export function normalizeSearchText(searchText: string): string {
    return searchText
        .replace(/\s*,\s*/gm, ',')
        .replace(/,$/, '')
        .trim();
}
